import React, {Component} from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import InfografikOpenData from "./infografik/InfografikOpenData";

export class PagesInfografikOpenData extends Component{
    render(){
        return(
            <div>
                <HeaderOpenData />
                <InfografikOpenData />
                <FooterOpenData />
            </div>
        )
    }
}

export default PagesInfografikOpenData;